<script>
export default {
  props: {
    years: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      position: this.getStartPosition(),
      numberOfRows: 4,
      numberOfColumns: 3,
    }
  },
  computed: {
    currentYears() {
      const result = []
      for (
        let i = this.years[this.position].start;
        i <= this.years[this.position].end;
        i++
      ) {
        result.push(i)
      }
      return result
    },
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    getStartPosition() {
      const currentYear = new Date().getFullYear()
      for (let i = this.years.length - 1; i >= 0; i--) {
        if (
          Math.abs(currentYear - this.years[i].start) <= 11 &&
          Math.abs(currentYear - this.years[i].end) <= 11
        ) {
          return i
        }
      }
      return -1
    },
    increasePosition() {
      if (this.position < this.years.length) {
        this.position++
      }
    },
    decreasePosition() {
      if (this.position > 0) {
        this.position--
      }
    },
    setYear(index) {
      this.$emit('set-year', this.currentYears[index])
    },
    getIndex(row, column) {
      return row * this.numberOfColumns + column
    },
  },
}
</script>

<template>
  <v-card>
    <v-card-title class="primary--text justify-center">Year</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="2" md="2"
          ><v-icon
            color="primary"
            dark
            :disabled="position === 0"
            @click="decreasePosition"
          >
            mdi-chevron-left
          </v-icon></v-col
        >
        <v-col cols="8" md="8" class="primary--text text-center"
          ><strong
            >{{ years[position].start }} - {{ years[position].end }}</strong
          ></v-col
        >
        <v-col cols="2" md="2">
          <v-icon
            color="primary"
            dark
            :disabled="position === years.length - 1"
            @click="increasePosition"
          >
            mdi-chevron-right
          </v-icon>
        </v-col>
      </v-row>
      <v-row
        v-for="(rowIndex, i) in numberOfRows"
        :key="'yearRowIndex-' + rowIndex"
      >
        <v-col
          v-for="(colIndex, j) in numberOfColumns"
          :key="'yearColIndex-' + colIndex"
        >
          <v-btn
            block
            text
            :max-width="mobile ? '20px' : '60px'"
            color="primary"
            @click="setYear(getIndex(i, j))"
          >
            {{ currentYears[getIndex(i, j)] }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
</style>
